import React, { useEffect, useState } from "react";
import AppWrapper from "../AppWrapper";
import {
  DataTable,
  EmptyState,
  IndexTable,
  LegacyCard,
  Page,
  Spinner,
  Text,
} from "@shopify/polaris";
import supabase from "../../supabase-client";
import {
  formatDate,
  formatFriendlyDate,
  numberWithCommas,
  formatPlate,
} from "../../utility/funcs";
import OdometerReviewModal from "./OdometerReviewModal";

function OdometerSubmissions() {
  const [reqs, setReqs] = useState(undefined);

  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("car_odometer_submissions")
        .select("*, car_id(plate, model(name))")
        .eq("status", "pending")
        .order("submitted_at", { ascending: true });
      if (error) {
        console.error(error);
        return;
      }
      setReqs(data);
    };

    if (reqs === undefined) fetchData();
  }, []);

  const columnHeadings = [
    { title: "Placa" },
    { title: "Modelo" },
    { title: "Odometro" },
    { title: "Fecha" },
  ];

  const rowMarkup =
    reqs === undefined
      ? []
      : reqs.map((req, index) => {
          return (
            <IndexTable.Row
              key={req.id}
              id={req.id}
              position={index}
              onClick={() => {
                setSelected(req);
                setModalOpen(true);
              }}
            >
              <IndexTable.Cell>{formatPlate(req.car_id.plate)}</IndexTable.Cell>
              <IndexTable.Cell>{req.car_id.model.name}</IndexTable.Cell>
              <IndexTable.Cell>
                {numberWithCommas(req.system_odometer_at_submission)}km
              </IndexTable.Cell>
              <IndexTable.Cell>{formatDate(req.submitted_at)}</IndexTable.Cell>
            </IndexTable.Row>
          );
        });

  const emptyRows = (
    <EmptyState heading="Estás al corriente 🎉">
      <Text>No hay ningun ajuste pendiente.</Text>
    </EmptyState>
  );

  const requestTable = () => {
    if (reqs === undefined) return <Spinner size="small" />;
    return (
      <LegacyCard>
        <IndexTable
          selectable={false}
          itemCount={rowMarkup.length}
          headings={columnHeadings}
          emptyState={emptyRows}
        >
          {rowMarkup}
        </IndexTable>
      </LegacyCard>
    );
  };

  return (
    <AppWrapper>
      <Page title="Ajustes de Odometro">
        {requestTable()}
        <OdometerReviewModal
          submission={selected}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onUpdated={(id) => {
            // Remove the processed request from list
            setReqs((prev) => prev.filter((r) => r.id !== id));
          }}
        />
      </Page>
    </AppWrapper>
  );
}

export default OdometerSubmissions;
